// test1976
(1976 && 0);
